export class StreetsRoutingConstants {
    static STREETS_ROUTE = "streets";
}
